// extracted by mini-css-extract-plugin
export default {"buttonContainer":"+tEfu","button":"ruue4","commentButtonIcon":"igmwM","commentButtonContent":"ppKcC","followButtonContent":"ONSsl","container":"lbpCT"};